import ProductPageSettingTab from "./productPageSettingTab.container";

export default ProductPageSettingTab;
